/**
 * 사업자등록번호 포맷 유틸.
 * 입력·표시·검증에서 공통으로 xxx-xx-xxxxx(하이픈) 형식을 맞춘다.
 */

export const BUSINESS_REGISTRATION_NUMBER_DIGIT_LENGTH = 10;
export const BUSINESS_REGISTRATION_NUMBER_MAX_LENGTH = 12;
export const BUSINESS_REGISTRATION_NUMBER_PLACEHOLDER = '000-00-00000';

/**
 * 숫자만 추출 후 xxx-xx-xxxxx 하이픈 자동 삽입.
 * 예: 1234567890 → 123-45-67890 (최대 10자리)
 */
export const formatBusinessRegistrationNumber = (value: string): string => {
  const digits = value
    .replace(/\D/g, '')
    .slice(0, BUSINESS_REGISTRATION_NUMBER_DIGIT_LENGTH);
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) {
    return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  }
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
};

/** 사업자등록번호 10자리(3-2-5) 형식인지 검증 */
export const isValidBusinessRegistrationNumber = (value: string): boolean => {
  const digits = value.replace(/\D/g, '');
  return digits.length === BUSINESS_REGISTRATION_NUMBER_DIGIT_LENGTH;
};
